import {mapToObjectDDL} from "../../../common/mapper";

export const toMapFields = (data) => {
    const {dataKTP, dataTambahan, dataMember, dataSistem} = data;

    const asalProspek = dataMember?.kategoriKhusus === "PEMBAWA" ? dataSistem?.asalProspekH23 : dataSistem?.asalProspekH1;
    return [
        // dataKTP
        {key: "name", value: dataKTP?.nama},
        {key: "nik", value: dataKTP?.nik},
        {key: "address", value: dataKTP?.alamat},
        {key: "kkNumber", value: dataKTP?.nomorKK},
        {key: "npwp", value: dataKTP?.npwp},
        {key: "provinceId", value: safeMapToObjectDDL(dataKTP?.provinsi?.provinceName, dataKTP?.provinsi?.id)},
        {key: "kabkotId", value: safeMapToObjectDDL(dataKTP?.kabkot?.kabKotName, dataKTP?.kabkot?.kabKotId)},
        {key: "kecamatanId", value: safeMapToObjectDDL(dataKTP?.kecamatan?.kecamatanName, dataKTP?.kecamatan?.id)},
        {key: "kelurahanId", value: safeMapToObjectDDL(dataKTP?.kelurahan?.kelurahanname, dataKTP?.kelurahan?.id)},
        {key: "zipcode", value: safeMapToObjectDDL(dataKTP?.kodePos, dataKTP?.kodePos)},
        {key: "gender", value: safeMapToObjectDDL(dataKTP?.jenisKelamin?.value, dataKTP?.jenisKelamin?.key)},
        {key: "job1", value: safeMapToObjectDDL(dataKTP?.job1?.value, dataKTP?.job1?.key)},
        {key: "job2", value: safeMapToObjectDDL(dataKTP?.job2?.value, dataKTP?.job2?.key)},
        {key: "religion", value: safeMapToObjectDDL(dataKTP?.agama?.value, dataKTP?.agama?.key)},

        // dataTambahan
        {key: "hpNumber1", value: dataTambahan?.nomorHp1},
        {key: "hpNumber2", value: dataTambahan?.nomorHp2},
        {key: "email", value: dataTambahan?.email},
        {key: "facebook", value: dataTambahan?.facebook},
        {key: "instagram", value: dataTambahan?.instagram},
        {key: "linkedin", value: dataTambahan?.linkedin},
        {key: "twitter", value: dataTambahan?.x},
        {key: "tiktok", value: dataTambahan?.tiktok},
        {key: "discCategory", value: safeMapToObjectDDL(dataTambahan?.kategoriDisc, dataTambahan?.kategoriDisc)},
        {key: "hobby", value: safeMapToObjectDDL(dataTambahan?.hobby?.[0]?.value, dataTambahan?.hobby?.[0]?.key)},
        {
            key: "interest",
            value: safeMapToObjectDDL(dataTambahan?.interest?.[0]?.value, dataTambahan?.interest?.[0]?.key)
        },

        // dataMember
        {key: "customerId", value: dataMember?.memberId},
        {key: "memberLevel", value: safeMapToObjectDDL(dataMember?.memberLevel, dataMember?.memberLevel)},
        {key: "loyaltyLevel", value: safeMapToObjectDDL(dataMember?.loyaltyLevel, dataMember?.loyaltyLevel)},
        {key: "specialCategory", value: safeMapToObjectDDL(dataMember?.kategoriKhusus, dataMember?.kategoriKhusus)},
        {key: "photoKTP", value: dataMember?.fotoKtpBase64},
        {key: "specialNotes", value: dataMember?.catatanKhusus},
        {key: "photoKK", value: dataMember?.fotoKartuKeluargaBase64},
        {key: "photoCustomerUrl", value: dataMember?.fotoProfilePictureBase64},

        // dataSistem
        {key: "kodeCabang", value: dataSistem?.kodeCabang},
        {key: "prospectDate", value: dataSistem?.tanggalProspek},
        {key: "prospectId", value: dataSistem?.nomorProspek},
        {key: "lastFUStatusH1", value: dataSistem?.statusFuTerakhirH1},
        {key: "lastFUStatusH23", value: dataSistem?.statusFuTerakhirH23},
        {key: "lastFUDate", value: dataSistem?.tanggalFuTerakhir},
        {key: "category", value: safeMapToObjectDDL(dataSistem?.jenisProspek, dataSistem?.jenisProspek)},
        {key: "source", value: safeMapToObjectDDL(asalProspek, asalProspek)},
        {key: "sourceCabang", value: dataSistem?.cabangAsal},
        {key: "lastFollowUpBy", value: dataSistem?.lastFollowUpBy},
        {key: "type", value: safeMapToObjectDDL(dataSistem?.jenisProspek, dataSistem?.jenisProspek)},
        {key: "lastBuyDate", value: dataSistem?.tanggalBeliTerakhir},
        {key: "lastServiceDate", value: dataSistem?.tanggalServiceTerakhir},
        {key: "sourceData", value: dataSistem?.sumberData},
        {key: "prospectOwnership", value: dataSistem?.pemilikProspek},
        {key: "lastSeller", value: dataSistem?.penjualTerakhir},
        {key: "lastLoginDate", value: dataSistem?.lastLoginDate},
        {key: "lastLoginTime", value: dataSistem?.lastLoginTime}
    ];
}

export const toDetailData = (data) => {
    const {dataKTP, dataTambahan, dataMember} = data;
    return {
        // dataKTP
        name: {value: dataKTP?.nama},
        nik: {value: dataKTP?.nik},
        address: {value: dataKTP?.alamat},
        kkNumber: {value: dataKTP?.nomorKK},
        npwp: {value: dataKTP?.npwp},
        provinceId: {value: safeMapToObjectDDL(dataKTP?.provinsi?.provinceName, dataKTP?.provinsi?.id)},
        kabkotId: {value: safeMapToObjectDDL(dataKTP?.kabkot?.kabKotName, dataKTP?.kabkot?.kabKotId)},
        kecamatanId: {value: safeMapToObjectDDL(dataKTP?.kecamatan?.kecamatanName, dataKTP?.kecamatan?.id)},
        kelurahanId: {value: safeMapToObjectDDL(dataKTP?.kelurahan?.kelurahanname, dataKTP?.kelurahan?.id)},
        zipcode: {value: safeMapToObjectDDL(dataKTP?.kodePos, dataKTP?.kodePos)},
        gender: {value: safeMapToObjectDDL(dataKTP?.jenisKelamin?.value, dataKTP?.jenisKelamin?.key)},
        job1: {value: safeMapToObjectDDL(dataKTP?.job1?.value, dataKTP?.job1?.key)},
        job2: {value: safeMapToObjectDDL(dataKTP?.job2?.value, dataKTP?.job2?.key)},
        religion: {value: safeMapToObjectDDL(dataKTP?.agama?.value, dataKTP?.agama?.key)},

        // dataTambahan
        hpNumber1: {value: dataTambahan?.nomorHp1},
        hpNumber2: {value: dataTambahan?.nomorHp2},
        email: {value: dataTambahan?.email},
        facebook: {value: dataTambahan?.facebook},
        instagram: {value: dataTambahan?.instagram},
        linkedin: {value: dataTambahan?.linkedin},
        twitter: {value: dataTambahan?.x},
        tiktok: {value: dataTambahan?.tiktok},
        discCategory: {value: safeMapToObjectDDL(dataTambahan?.kategoriDisc, dataTambahan?.kategoriDisc)},
        hobby: {value: safeMapToObjectDDL(dataTambahan?.hobby?.[0]?.value, dataTambahan?.hobby?.[0]?.key)},
        interest: {value: safeMapToObjectDDL(dataTambahan?.interest?.[0]?.value, dataTambahan?.interest?.[0]?.key)},

        // dataMember
        customerId: {value: dataMember?.memberId},
        memberLevel: {value: safeMapToObjectDDL(dataMember?.memberLevel, dataMember?.memberLevel)},
        loyaltyLevel: {value: safeMapToObjectDDL(dataMember?.loyaltyLevel, dataMember?.loyaltyLevel)},
        specialCategory: {value: safeMapToObjectDDL(dataMember?.kategoriKhusus, dataMember?.kategoriKhusus)},
        photoKTP: {value: dataMember?.fotoKtpBase64},
        specialNotes: {value: dataMember?.catatanKhusus},
        photoKK: {value: dataMember?.fotoKartuKeluargaBase64},
        photoCustomerUrl: {value: dataMember?.fotoProfilePictureBase64},

        // dataSistem
        // kodeCabang: { value: dataSistem?.kodeCabang },
        // prospectDate: { value: dataSistem?.tanggalProspek },
        // prospectId: { value: dataSistem?.nomorProspek },
        // lastFUStatusH1: { value: dataSistem?.statusFuTerakhirH1 },
        // lastFUStatusH23: { value: dataSistem?.statusFuTerakhirH23 },
        // lastFUDate: { value: dataSistem?.tanggalFuTerakhir },
        // category: { value: safeMapToObjectDDL(dataSistem?.jenisProspek, dataSistem?.jenisProspek) },
        // source: { value: safeMapToObjectDDL(dataSistem?.asalProspek, dataSistem?.asalProspek) },
        // sourceCabang: { value: dataSistem?.cabangAsal },
        // lastFollowUpBy: { value: dataSistem?.lastFollowUpBy },
        // type: { value: safeMapToObjectDDL(dataSistem?.jenisProspek, dataSistem?.jenisProspek) },
        // lastBuyDate: { value: dataSistem?.tanggalBeliTerakhir },
        // lastServiceDate: { value: dataSistem?.tanggalServiceTerakhir },
        // sourceData: { value: dataSistem?.sumberData },
        // prospectOwnership: { value: dataSistem?.pemilikProspek },
        // lastSeller: { value: dataSistem?.penjualTerakhir },
        // lastLoginDate: { value: dataSistem?.lastLoginDate },
        // lastLoginTime: { value: dataSistem?.lastLoginTime }
    }
}


const safeMapToObjectDDL = (label, value) => {
    let result = [];
    if (label !== undefined && value !== undefined) {
        result = mapToObjectDDL(label, value);
    }
    return result;
};

export const transformProspectData = (input) => {
    return {
        dataKTP: {
            nama: input.name,
            nik: input.nik,
            alamat: input.address,
            nomorKK: input.kkNumber,
            npwp: input.npwp,
            provinsi: {
                id: input.provinceId?.value,
                provinceName: input.provinceId?.label,
            },
            kabkot: {
                kabKotId: input.kabkotId?.value,
                kabKotName: input.kabkotId?.label,
                idProvince: input.provinceId?.value,
            },
            kecamatan: {
                id: input.kecamatanId?.value,
                kecamatanName: input.kecamatanId?.label,
                idKabKot: input.kabkotId?.value,
            },
            kelurahan: {
                id: input.kelurahanId?.value,
                kelurahanname: input.kelurahanId?.label,
                idkecamatan: input.kecamatanId?.value,
                zipcode: input.zipcode?.value,
            },
            kodePos: input.zipcode?.value,
            jenisKelamin: {
                key: input.gender?.value,
                value: input.gender?.label,
                bizparCategory: "GENDER_TYPE",
            },
            job1: {
                key: input.job1?.value,
                value: input.job1?.label,
                bizparCategory: "JOB_TYPE",
            },
            job2: {
                key: input.job2?.value,
                value: input.job2?.label,
                bizparCategory: "JOB_TYPE",
            },
            agama: {
                key: input.religion?.value,
                value: input.religion?.label,
                bizparCategory: "RELIGION_TYPE",
            },
        },
        dataTambahan: {
            nomorHp1: input.hpNumber1,
            nomorHp2: input.hpNumber2,
            email: input.email,
            facebook: input.facebook,
            instagram: input.instagram,
            linkedin: input.linkedin,
            x: input.twitter,
            tiktok: input.tiktok,
            kategoriDisc: input.discCategory?.value,
            hobby: Array.isArray(input.hobby)
                ? input.hobby.map(item => ({
                    key: item.value,
                    value: item.label,
                    bizparCategory: "HOBBY_TYPE",
                }))
                : [
                    {
                        key: input.hobby?.value,
                        value: input.hobby?.label,
                        bizparCategory: "HOBBY_TYPE",
                    },
                ],
            interest: Array.isArray(input.interest)
                ? input.interest.map(item => ({
                    key: item.value,
                    value: item.label,
                    bizparCategory: "INTEREST_TYPE",
                }))
                : [
                    {
                        key: input.interest?.value,
                        value: input.interest?.label,
                        bizparCategory: "INTEREST_TYPE",
                    },
                ],
        },
        dataMember: {
            memberId: input.customerId,
            memberLevel: input.memberLevel?.value,
            loyaltyLevel: input.loyaltyLevel?.value,
            kategoriKhusus: input.specialCategory?.value,
            catatanKhusus: input.specialNotes,
            fotoKtpBase64: input.photoKTP,
            fotoKartuKeluargaBase64: input.photoKK,
            fotoProfilePictureBase64: input.photoCustomerUrl,
        },
        dataSistem: {
            kodeCabang: input.kodeCabang !== null ? input?.kodeCabang : input?.sourceCabang,
        },
    };
};